<template>
  <div>
    <h1>Tipos de Certificados</h1>

	<div class="texto">
		<ul class="lista-downloads">
			<li class="prod">Política A1</li>
		</ul>
		<p>
			Certificados de política A1 são aqueles em que a chave privada é gerada em software, e fica armazenada
			em um arquivo ou programa de computador. É possível e recomendável realizar cópia de segurança do certificado.
			A validade máxima do certificado A1 é de um ano.
		</p>
		<br/>

		<a name="precos"></a>
		<ul class="lista-downloads">
			<li class="prod">Preços de Referência</li>
		</ul>
		<p>
			Apresentamos a seguir os diferentes tipos de certificados digitais da Soluti.
		</p>
		<br/>

    <ccd-tipos-precos></ccd-tipos-precos>
	</div>
  </div>
</template>

<script>
import Precos from './Precos.vue';

export default {
  components: {
    'ccd-tipos-precos': Precos
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Tipos.vue?19393c70